import React from "react";
import _ from "lodash";
import ClassNames from "classnames";

import Button from "@material-ui/core/Button";
import LinkIcon from "@material-ui/icons/Link";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import ScoreOverwriteInput from "../../components/ScoreOverwriteInput";
import ScoreOverwrite from "../../components/ScoreOverwrite";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";

export default function SubjectListWithTarget({
  list,
  hasSkillSelect,
  finalData,
  setFinalData,
  hideCurrent,
  allowOverwriting,
  getOverwriting,
  hideProjectTargetKpi,
  hideCurrentMetrics,
  hideTargetMetrics,
  isReadOnly,
  ...props
}) {
  const { t } = useTranslation();
  const isScoreOverwritten = (subjectId) => {
    if (finalData) {
      const overwritePass = finalData.find(
        (o) => o.subject_id === subjectId
      ).overwrite_pass;
      return overwritePass === 1 ? true : false;
    }
    return false;
  };
  return (
    <div className={styles.container}>
      <div className={styles.subjectList}>
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            const failed = item.kpi_status === 'Fail';
            const isKPIStatusNA = item.kpi_status === '';
            return (
              <div key={index} className={styles.listItemWrapper}>
                <div className={styles.listItem}>
                  <div className={styles.index}>
                    <div>{index + 1}</div>
                  </div>
                  <div className={styles.listItemDetails}>
                    <div className={styles.subjectName} title={item.subject}>
                      {item.subject}
                      {item.sub_subject ? " — " + item.sub_subject : ""}
                    </div>
                    {!hideProjectTargetKpi && (
                      <div className={styles.targetMetrics}>
                        <div className={styles.targetMetricsLabel}>
                          {t("growForm.projectTargetKpi")}
                        </div>
                        <div
                          className={styles.targetMetricsValue}
                          title={item.project_target_kpi}
                        >
                          <span>{item.project_target_kpi !== "undefined" ? item.project_target_kpi : ""}</span>
                        </div>
                      </div>
                    )}
                    {!hideCurrentMetrics && (
                      <div className={styles.targetMetrics}>
                        <div className={styles.targetMetricsLabel}>
                          {t("growForm.mtd")}
                        </div>
                        <div
                          className={styles.targetMetricsValue}
                          title={item.mtd_metric}
                        >
                          <span>{item.mtd_metric}</span>
                        </div>
                      </div>
                    )}
                    {!hideCurrentMetrics && (
                      <div className={styles.subjectMetrics}>
                        <div className={styles.subjectMetricsValueLabel}>
                          {t("growForm.current")}
                        </div>
                        <div
                          className={styles.subjectMetricsValue}
                          title={item.result_metrics}
                        >
                          <span>{item.result_metrics}</span>
                        </div>

                        {item.document_link && item.document_link.length > 0 && (
                          <Button
                            className={styles.viewLinkBtn}
                            variant="outlined"
                            disableRipple
                            disableElevation
                            title={item.document_link}
                            onClick={() => {
                              window.open(item.document_link);
                            }}
                          >
                            <LinkIcon className={styles.viewLinkBtnIcon} />
                            <span className={styles.viewLinkBtnLabel}>
                              View link
                            </span>
                          </Button>
                        )}
                      </div>
                    )}
                    {!hideCurrentMetrics && (
                      <div className={styles.targetMetrics}>
                        <div className={styles.targetMetricsLabel}>
                          {t("growForm.target")}
                        </div>
                        <div
                          className={styles.targetMetricsValue}
                          title={item.reality_target}
                        >
                          <span>{item.reality_target}</span>
                        </div>
                      </div>
                    )}

                    {/* TODO: renamed classname and dirty styling later */}
                    {!hideCurrentMetrics && item.skill_improvement_level_1 && (
                      <div
                        className={ClassNames(
                          styles.subjectMetricsRow,
                          styles.subjectSkillSelectRow
                        )}
                      >
                        <div className={styles.subjectMetricsLabel}>
                          {t("growForm.skillToImprove")}
                        </div>
                        <div className={styles.subjectMetricsContent}>
                          <div className={styles.subjectMetricsValue}>
                            <span>
                              {item.skill_improvement_level_1}{" "}
                              {item.skill_improvement_level_2
                                ? " — " + item.skill_improvement_level_2
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {finalData && (
                      <>
                        <div className={styles.targetMetrics}>
                          <div className={styles.targetMetricsLabel}>
                            {t("reviewSession.final")}{" "}
                          </div>
                          <div
                            className={ClassNames(
                              styles.targetMetricsValue,
                              styles.metricFinal
                            )}
                          >
                            <div
                              className={ClassNames(
                                styles.status,
                                isKPIStatusNA ? '' : (
                                  failed ? styles.failed : styles.success
                                )
                              )}
                            >
                              <span>
                                {
                                  finalData.find(
                                    (o) => o.subject_id === item.subject_id
                                  ).review_progress_score
                                }
                              </span>
                              {!isKPIStatusNA && (failed ? (
                                <ErrorIcon className={styles.icon} />
                              ) : (
                                <CheckCircleIcon className={styles.icon} />
                              ))}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {allowOverwriting && failed && (
                  <ScoreOverwriteInput
                    data={finalData}
                    disabled={!!isReadOnly}
                    onCheckChange={(checked) => {
                      if (finalData) {
                        let index = finalData.findIndex(
                          (o) => o.subject_id === item.subject_id
                        );
                        if (index > -1) {
                          let newFinalData = _.cloneDeep(finalData);
                          newFinalData[index].overwrite_pass = checked ? 1 : 0;
                          setFinalData(newFinalData);
                        }
                      }
                    }}
                    onTextChange={(text) => {
                      if (finalData) {
                        let index = finalData.findIndex(
                          (o) => o.subject_id === item.subject_id
                        );
                        if (index > -1) {
                          let newFinalData = _.cloneDeep(finalData);
                          newFinalData[index].reason_overwrite_pass = text;
                          setFinalData(newFinalData);
                        }
                      }
                    }}
                    placeholderText={"Reason for overwriting"}
                  />
                )}

                {getOverwriting && isScoreOverwritten(item.subject_id) && (
                  <ScoreOverwrite
                    overwriteReason={
                      finalData.find((o) => o.subject_id === item.subject_id)
                        .reason_overwrite_pass
                    }
                  />
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}